import {
  AutoCompleteRequest,
  EquipmentIDAutocompleteResponse,
  SCACAutocompleteResponse,
  UsersAutocompleteResponse,
} from "@telegraphio/bapi-types";
import apiClient, { CustomFetchError } from "../openApiClient";
import { ApiError } from "@/bapi-client/errors";

export interface AutocompleteApi {
  autocompleteEquipmentId(
    customerId: string,
    requestData: AutoCompleteRequest,
  ): Promise<EquipmentIDAutocompleteResponse>;
  autocompleteScac(customerId: string, requestData: AutoCompleteRequest): Promise<SCACAutocompleteResponse>;
  autocompleteUsers(customerId: string, requestData: AutoCompleteRequest): Promise<UsersAutocompleteResponse>;
}

export const autocompleteApi: AutocompleteApi = {
  async autocompleteEquipmentId(
    customerId: string,
    requestData: AutoCompleteRequest,
  ): Promise<EquipmentIDAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/equipment_id`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      const errorMessage = Array.isArray(error)
        ? error.map((e) => e.msg).join(", ")
        : (error as CustomFetchError)?.message || "Failed to get autocomplete equipment id";

      throw ApiError.create(errorMessage, response?.status, error);
    }

    return data;
  },

  async autocompleteScac(customerId: string, requestData: AutoCompleteRequest): Promise<SCACAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/scac`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      const errorMessage = Array.isArray(error)
        ? error.map((e) => e.msg).join(", ")
        : (error as CustomFetchError)?.message || "Failed to get autocomplete scac";

      throw ApiError.create(errorMessage, response?.status, error);
    }
    return data;
  },

  async autocompleteUsers(customerId: string, requestData: AutoCompleteRequest): Promise<UsersAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/users`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      const errorMessage = Array.isArray(error)
        ? error.map((e) => e.msg).join(", ")
        : (error as CustomFetchError)?.message || "Failed to get autocomplete users";

      throw ApiError.create(errorMessage, response?.status, error);
    }
    return data;
  },
};
